import { getEndpointUrl } from './Common';

class AppConfigService {
    static async getAppConfig() {
        try {
            const response = await fetch(`${getEndpointUrl()}/v2/options`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            
            if (data.status === 'success') {
                return data.results;
            } else {
                throw new Error(data.message || 'Failed to fetch app config');
            }
        } catch (error) {
            console.error('Error fetching app config:', error);
            throw error;
        }
    }

    static getDefaultConfig() {
        return {
            app_name: "Pro Inspector Independent",
            signature_name: "",
            signature_role: "",
            bank_name: "",
            bank_account_number: "",
            bank_holder_name: "",
            logo_filename: "",
            signature_stamp_filename: "",
            signature_filename: "",
            offer_tnc: "",
        };
    }
}

export default AppConfigService;